import { useEffect, useState } from 'react';
import ApiDatabase from 'server';

// Its own key: the company panel reads the same route under the default one,
// and neither should cancel the other.
export const INVOICE_COMPANY_ABORT_KEY = 'admin/getCompanyInfo|invoiceDetail';

/**
 * The company of the invoice detail (JBWEB-1274), for its post-it, its
 * remuneration conditions and its bonuses. Held by the panel rather than by
 * its tab, so that switching tabs does not read it again. `company` is null
 * while read, and for an invoice without a company; `failed` says the read
 * did not succeed.
 */
const useInvoiceCompany = (companyId) => {
  const [state, setState] = useState({ company: null, failed: false });

  useEffect(() => {
    setState({ company: null, failed: false });
    if (!companyId) return undefined;
    let active = true;
    ApiDatabase.getCompanyInfo(
      { idCompany: companyId },
      (data) => {
        if (!active) return;
        // A company the api cannot find comes back as `[]`, which would read
        // as a company on its defaults.
        const company = data?.company?._id ? data.company : null;
        setState({ company, failed: !company });
      },
      (error) => {
        if (!active || error?.name === 'CanceledError') return;
        // Never the error object in the console: axios keeps the request, token included.
        setState({ company: null, failed: true });
      },
      { abortKey: INVOICE_COMPANY_ABORT_KEY },
    );
    return () => {
      active = false;
    };
  }, [companyId]);

  useEffect(
    () => () => ApiDatabase.abortRequest(INVOICE_COMPANY_ABORT_KEY),
    [],
  );

  return state;
};

export default useInvoiceCompany;
